import { ProtectedRoute } from "@/components/protected-route";
import { useSession } from "@/services/auth";
import { Navigate, Outlet, useLocation } from "react-router";

export function OnboardingLayout() {
  const { customer } = useSession();
  const location = useLocation();

  const hasCompletedOnboarding = !!customer?.billing?.id;
  const currentPath = location.pathname;

  // If completed onboarding, redirect away from all onboarding screens
  if (hasCompletedOnboarding && currentPath.startsWith("/onboarding")) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <ProtectedRoute>
      <Outlet />
    </ProtectedRoute>
  );
}
